import { render, staticRenderFns } from "./HollowCard.vue?vue&type=template&id=47fdbbac&scoped=true&"
import script from "./HollowCard.vue?vue&type=script&lang=ts&"
export * from "./HollowCard.vue?vue&type=script&lang=ts&"
import style0 from "./HollowCard.vue?vue&type=style&index=0&id=47fdbbac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fdbbac",
  null
  
)

export default component.exports